/* IMGENATECH — animations au défilement (légères, sans dépendance) */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Léger effet de profondeur sur le visuel principal */
  function parallax() {
    if (reduce) return;
    var media = document.querySelector('[data-ig-parallax]');
    if (!media) return;
    var img = media.querySelector('img');
    if (!img) return;
    var ticking = false;
    function update() {
      var r = media.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var y = Math.max(0, -r.top) * 0.18;
        img.style.translate = '0 ' + y.toFixed(1) + 'px';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
  }

  function init() {
    window.__igInit = true;
    root.classList.add('ig-js');
    reveal(document);
    parallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Compatibilité éditeur de thème : réactiver les animations sur les sections rechargées */
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
